import { useAppSelector } from '../../../app/hooks';
import useWebSocketAlert from '../../../hooks/useWebSocketAlert.hooks';

/**
 * WebSocket connection-alert wiring for the center pane: the event/audio
 * connection messages + the two useWebSocketAlert show/close controllers.
 * Extracted from MainPageLayout — this is CenterPane's concern, not the
 * layout root's.
 */
const useConnectionAlerts = () => {
  const eventWSConnectionMessage = useAppSelector(
    (state) => state.messages.eventWSConnectionMessage
  );
  const audioWSConnectionMessage = useAppSelector(
    (state) => state.messages.audioWSConnectionMessage
  );
  const eventWSConnectionSuccess = useAppSelector(
    (state) => state.messages.eventWSConnectionSuccess
  );
  const audioWSConnectionSuccess = useAppSelector(
    (state) => state.messages.audioWSConnectionSuccess
  );

  const { showAlert: showEventAlert, handleCloseAlert: handleCloseEventAlert } =
    useWebSocketAlert({
      wsConnectionMessage: eventWSConnectionMessage,
      wsConnectionSuccess: eventWSConnectionSuccess,
    });

  const { showAlert: showAudioAlert, handleCloseAlert: handleCloseAudioAlert } =
    useWebSocketAlert({
      wsConnectionMessage: audioWSConnectionMessage,
      wsConnectionSuccess: audioWSConnectionSuccess,
    });

  return {
    eventWSConnectionMessage,
    audioWSConnectionMessage,
    eventWSConnectionSuccess,
    audioWSConnectionSuccess,
    showEventAlert,
    handleCloseEventAlert,
    showAudioAlert,
    handleCloseAudioAlert,
  };
};

export default useConnectionAlerts;
